
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 297 297"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"red"}},[_c('path',{attrs:{"d":"M229.554 145.738l4.264-51.168h7.462c5.646 0 10.224-4.578 10.224-10.224V65.688c0-17.596-14.316-31.912-31.912-31.912h-35.564v-4.723C184.028 13.032 170.994 0 154.975 0h-29.82c-16.02 0-29.052 13.032-29.052 29.052v4.723H60.539c-17.596 0-31.912 14.316-31.912 31.912v18.658c0 5.646 4.578 10.224 10.224 10.224h7.462L60.205 261.3c1.668 20.019 18.711 35.7 38.799 35.7h82.119c19.849 0 36.715-15.313 38.723-34.991 27.664-5.705 48.527-30.251 48.527-59.579.001-25.781-16.128-47.851-38.819-56.692zM116.551 29.052c0-4.744 3.86-8.604 8.604-8.604h29.82c4.745 0 8.605 3.86 8.605 8.604v4.723h-47.029v-4.723zM49.073 74.123v-8.435c0-6.322 5.143-11.465 11.465-11.465h159.053c6.322 0 11.465 5.143 11.465 11.465v8.435H49.073zm132.051 202.429H99.005c-9.538 0-17.63-7.445-18.422-16.95L66.83 94.57h146.469l-3.923 47.076c-.611-.018-1.22-.047-1.835-.047-33.543 0-60.831 27.289-60.831 60.831 0 30.647 22.785 56.06 52.303 60.221-2.071 7.999-9.399 13.901-17.889 13.901zm26.417-33.738c-22.268 0-40.384-18.116-40.384-40.384s18.116-40.384 40.384-40.384 40.384 18.116 40.384 40.384-18.116 40.384-40.384 40.384z"}}),_c('path',{attrs:{"d":"M222.002 202.431l9.64-9.64c3.991-3.993 3.991-10.467-.002-14.459-3.994-3.992-10.465-3.992-14.459 0l-9.64 9.64-9.64-9.64c-3.994-3.992-10.465-3.992-14.459 0-3.993 3.993-3.993 10.466 0 14.459l9.64 9.64-9.64 9.64c-3.993 3.993-3.993 10.466 0 14.459 1.997 1.996 4.613 2.994 7.23 2.994s5.233-.998 7.23-2.994l9.64-9.64 9.64 9.64a10.194 10.194 0 007.23 2.994c2.617 0 5.233-.998 7.23-2.994 3.993-3.993 3.993-10.466 0-14.459l-9.64-9.64z"}})])])
          )
        }
      }
    